import { render, staticRenderFns } from "./OverviewSection.vue?vue&type=template&id=969b4896&scoped=true&"
import script from "./OverviewSection.vue?vue&type=script&lang=js&"
export * from "./OverviewSection.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSection.vue?vue&type=style&index=0&id=969b4896&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969b4896",
  null
  
)

export default component.exports